export default __webpack_public_path__ + "static/media/data_dup.a3ef94e9.png";